import { Button as HeroButton, type ButtonProps as HeroButtonProps } from '@heroui/react';
import { cn } from '@/lib/utils';

export type ButtonProps = Omit<HeroButtonProps, 'isDisabled'> & {
  disabled?: boolean;
  isDisabled?: boolean;
};

export function Button({
  className,
  disabled,
  isDisabled,
  variant = 'primary',
  ...props
}: ButtonProps) {
  return (
    <HeroButton
      variant={variant}
      className={cn(
        'cursor-pointer',
        variant === 'primary' && 'text-primary-foreground',
        (variant === 'ghost' || variant === 'outline') && 'text-foreground hover:text-foreground',
        className,
      )}
      isDisabled={isDisabled ?? disabled}
      {...props}
    />
  );
}
